/* eslint-disable */
import React from "react";
import TextLoop from "react-text-loop";
import { Button, Grid } from 'tabler-react';
import Confetti from 'react-dom-confetti';
import './drawWinner.css'
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Box from "@material-ui/core/Box";
import ls from "local-storage";

import {
  Input,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
 
} from "@material-ui/core";

const styles = {
  button: {
    marginLeft: 8,
    marginBottom: "40px",
    position: "relative",
    backgroundColor: "#171942",
    color: "white",
  },
};
import { db, auth } from "../Firebase/firebase.js";

export default function DrawWinnerPage() {



  
  const useStyles = makeStyles(styles);

  const [prize, setPrize] = React.useState("");
  const [showResult, setShowResult] = React.useState(false);
  const [result, setResult] = React.useState("");


  const [items, setItems] = React.useState("");
  const [selectedPrize, setSelectedPrize] = React.useState([]);
  const [prizeType , setPrizeType] = React.useState("")
  const [users, setUser] = React.useState([]);
  const [userNames, setUserNames] = React.useState([]);
  const [ticketCount, setTicketCount] = React.useState([]);


  const handleChange = (event) => {
    setPrize(event.target.value);
    ls.set("prizeSelected", event.target.value);
    getFishermen();
  };

  const handleChangeTypeChange = (event)=>{
    setPrizeType(event.target.value);
  }
  const handleChangeItem = (event) => {
    setItems(event.target.value);
  };


  var getFishermen = () => {
   
    let newArray = [];
    db.collection("prizes").where("type", "==" ,ls.get("prizeSelected"))
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
     
        });
        setSelectedPrize(newArray);
        getTickets();
     
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };


  var getTickets = () => {
    let newArray = [];
    let userName = [];
    let ticketCount = [];
    
    db.collection("category").doc(ls.get("prizeSelected")).collection("tickets"). where("ticket_count", ">" ,0)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data().registerationId);
          userName.push(doc.data().registerationName)
          ticketCount.push(doc.data().ticket_count)
     
        });
      
        setUserNames(userName);
        setUser(newArray);
        setTicketCount(ticketCount);

      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };


  var drawWinners = () => {
    getTickets()  

    let maxItemIndex = userNames.length;
    const randomIndex = Math.floor(Math.random() * maxItemIndex);
   setResult(userNames[randomIndex]);
   db.collection("category").doc(ls.get("prizeSelected")).collection("tickets").doc(users[randomIndex]).update({
     'ticket_count' : ticketCount[randomIndex]-1
   })

    setTicketCount(ticketCount[randomIndex]-1);

    if (ticketCount[randomIndex] > 0){
      console.log(selectedPrize[randomIndex]);
      
      var index;
      for ( var x =0 ; x < selectedPrize.length ; x++){
        if (prizeType == selectedPrize[x].name){
            index = x;
            break;
        }
      }



      db.collection("winners").doc().set({
        "registrationId" : users[randomIndex],
        "prizeCategory" : ls.get("prizeSelected"),
        "prizeName": selectedPrize[index].name,
        "image" :  selectedPrize[index].image
      });
       setShowResult(true);
   
      
   
       setTimeout(() => {
         setShowResult(false);
         getTickets()  

       }, 7000);
   
      
    }
  
    
    
  };

  React.useEffect(() => {
    
    //getTickets()  ;
   getFishermen();
    
  },[] );

  const classes = useStyles();
  return (
    <>
      <Box pl={1}>
        <FormControl
          variant="outlined"
          className={classes.formControl}
          style={{ width: 267 }}
          required
        >
          <InputLabel id="event_label">Category</InputLabel>
          <Select
            labelId="prize"
            id="prize"
            value={prize}
            onChange={handleChange}
            
            label="Prize"
          >
            <MenuItem value="Door">Door</MenuItem>
            <MenuItem value="Medium">Medium</MenuItem>
            <MenuItem value="Large">Large</MenuItem>
            <MenuItem value={"AdultCashPrizes"}>Adult Cash Prizes</MenuItem>
                      <MenuItem value={"YouthCashPrizes"}>Youth Cash Prizes</MenuItem>
            
          </Select>
        </FormControl>
      </Box>
    <br></br>
    <br></br>
      <Box pl={1}>
        <FormControl
          variant="outlined"
          className={classes.formControl}
          style={{ width: 267 }}
          required
        >
          <InputLabel id="event_label">Select prize</InputLabel>

          <Select
    
      // onClick={()=>getFishermen()}
      
            labelId="prizeType"
            id="prizeType"
            value={prizeType}
            onChange={handleChangeTypeChange}
            label="PrizeType"
          >
            {selectedPrize.map((row) => (
              <MenuItem key={row.docId} value={row.name}> {row.name}</MenuItem>
              
            ))}
          </Select>
        </FormControl>
      </Box>

      

      <br></br>
      {users.length !== 0 && (
          <div className="draw-block">
            <Grid.Row>
              <Grid.Col md={2} sm={12}>
                <div className="draw-section">
                  <Box pl={6} sm={23} >

                    <div style={{height:15}}>

                    </div>

                  <TextLoop
                      className="draw-text"
                      interval={200}
                      springConfig={{ stiffness: 180, damping: 8 }}
                      children={userNames}
                    />

                
                  <Confetti active={showResult} />
                  </Box>
                  {/* <div style={{height:15}}>

                    </div> */}
                    <br>
                    </br>
                   <br></br>
                   Congratulations
                    <br></br> 
                    <p>{showResult &&   result}</p>
                </div>
                <Button
                  pill
                  block
                  name="drawButton"
                  color="primary"
                  onClick={()=> drawWinners() }
                >
                 
                  Draw
                </Button>
              </Grid.Col>
             
            </Grid.Row>
          </div>
    )}
    </>
  );
}
